import api from './../utils/api';


// Centralized error handler
const handleError = (error) => {
  if (error.response) {
    throw new Error(error.response.data.message || "Có lỗi xảy ra.");
  } else if (error.request) {
    throw new Error("Lỗi mạng! Vui lòng kiểm tra kết nối của bạn.");
  } else {
    throw new Error(error);
  }
};

export const forgotPassword = async (email) => {
  try {
    const response = await api.post(`/auth/forgot-password`, {
      email
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const resetPassword = async (token, newPassword) => {
  try {
    const response = await api.post(`/auth/reset-password`, {
      token,
      newPassword
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};
// Login function

export const login = async (username, password) => {
  try {
    const response = await api.post(`/auth/login`, {
      username,
      password,
    });
    localStorage.setItem("accessToken", response.data.data.accessToken);

    return response.data;
  } catch (error) {
    throw error;
  }
};

// Logout function
export const logout = async () => {
  try {
    const response = await api.post(`/auth/logout`, {},
      {
        withCredentials: true
      }
    );

    return response.data;
  } catch (error) {
    console.log("Log out error: " + error);
  }
};

// Register function
export const register = async (username, email, password) => {
  try {
    const response = await api.post(`/auth/register`, {
      username,
      email,
      password,
    },{
        withCredentials: true
      });

    return response.data;
  } catch (error) {
    handleError(error);
  }
};
